module.exports = __webpack_public_path__ + "static/media/bg_plan.3d9e4b81.jpg";